export default __webpack_public_path__ + "static/media/angular-icon-logo.2a94d7a4.png";